module.exports = __webpack_public_path__ + "media/components/switch-units/static/sailboat-012f6afcdac5112cf97516dae27d7aef.svg";